import React from "react";

  function CloseParen(props) {
    return (
      <svg viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M10 3C12.2415 5.33579 13.6191 8.50702 13.6191 12C13.6191 15.493 12.2415 18.6642 10 21" stroke="currentColor" stroke-width="2"/>
      </svg>
    );
  }
  export default CloseParen;